import { useEffect, useState } from "react";
import { call, money } from "../utils/appData";
export default function ProPrice({ inline = false }) {
  const [price, setPrice] = useState(null);
  useEffect(() => {
    let active = true;
    call("getWebSubscriptionPrices")
      .then((p) => {
        if (active) setPrice(p.monthly);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  return (
    <span
      className={
        inline
          ? "font-bold text-[#b45309] dark:text-[#e0a33a]"
          : "my-2.5 block text-[28px] font-extrabold"
      }
    >
      {price
        ? `${money(price.amount, price.currency)}/${inline ? "mo" : "month"}`
        : "View membership plans"}
    </span>
  );
}
